module.exports = __webpack_public_path__ + "assets/Terrorism-white.4d6c31da.svg";